"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Editor_1 = require("../../sections/products/Editor");
const react_router_dom_1 = require("react-router-dom");
const smartpadel_logo_png_1 = __importDefault(require("../../assets/smartpadel_logo.png"));
const ProductsForm = () => {
    const { id } = (0, react_router_dom_1.useParams)();
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'form-container', children: [(0, jsx_runtime_1.jsx)(Editor_1.Editor, { id: id }), (0, jsx_runtime_1.jsx)("img", { src: smartpadel_logo_png_1.default, alt: "Company Logo", className: "company-logo" })] }));
};
exports.ProductsForm = ProductsForm;
